var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmaDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 144,
    height: 97.742,
    viewBox: "0 0 144 97.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1390",
    "data-name": "Ret\\xE2ngulo 1390",
    width: 144,
    height: 97.742,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2036",
    "data-name": "Grupo 2036",
    transform: "translate(-788 -2244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2035",
    "data-name": "Grupo 2035",
    transform: "translate(788 2244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1212",
    "data-name": "Caminho 1212",
    d: "M209.483,60.546l10.682-10.682-8.851-8.842-3.557,3.556-1.836-1.836,3.561-3.561-3.561-3.561,1.836-1.836,3.565,3.565,5.286-5.285-5.29-5.29-3.561,3.561L205.926,28.5l5.4-5.4,8.239,8.239V42.139l-4.676-4.676-1.725,1.725L222,48.034l0-17.7L211.319,19.653,202.477,28.5l3.556,3.556L204.2,33.9l-3.561-3.561L197.076,33.9,195.24,32.06l3.565-3.565-5.285-5.286-5.29,5.29,3.561,3.561-1.832,1.832-5.4-5.4,8.239-8.238h10.794l-4.676,4.676,1.724,1.725,8.846-8.841-17.7,0L181.108,28.5l8.851,8.842,3.556-3.556,1.836,1.836-3.561,3.561,3.561,3.561-1.836,1.836-3.565-3.565L184.664,46.3l5.29,5.29,3.561-3.561,1.832,1.832-5.4,5.4-8.238-8.239V36.224l4.676,4.676,1.725-1.725-8.841-8.846,0,17.7L189.954,58.71l8.842-8.851L195.24,46.3l1.836-1.836,3.561,3.561,3.561-3.561,1.836,1.836-3.565,3.565,5.285,5.285,5.29-5.29L209.483,46.3l1.832-1.832,5.4,5.4-8.238,8.238H197.679l4.676-4.676-1.725-1.725-8.844,8.839,0,0Zm1.836-30.322,1.84,1.841L211.323,33.9l-1.84-1.841ZM191.679,28.5l1.841-1.841,1.836,1.836-1.841,1.841Zm-1.725,19.64-1.84-1.841,1.836-1.836,1.841,1.84Zm10.682-14.355,1.836,1.836-1.836,1.836L198.8,35.621Zm-3.561,7.233-1.836-1.836,1.836-1.836,1.836,1.836Zm3.561,3.561L198.8,42.742l1.836-1.836,1.836,1.836Zm1.725-5.4,1.836-1.836,1.836,1.836L204.2,41.017Zm7.233,10.682-1.84,1.841-1.836-1.836,1.84-1.841Z",
    transform: "translate(-128.636 -12.783)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1213",
    "data-name": "Caminho 1213",
    d: "M163.894,36.322V16.474L177.929,2.439h19.848l14.035,14.035V36.322L197.777,50.357H177.929ZM176.918,0,161.455,15.464V37.332L176.918,52.8h21.869l15.463-15.463V15.464L198.787,0Z",
    transform: "translate(-115.853)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2034",
    "data-name": "Grupo 2034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2033",
    "data-name": "Grupo 2033",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1214",
    "data-name": "Caminho 1214",
    d: "M155.061,325.706v-8.012h3.375a2.464,2.464,0,1,1,0,4.924h-2.174v3.087Zm3.219-6.955h-2.018v2.811h2.018a1.407,1.407,0,1,0,0-2.811",
    transform: "translate(-111.265 -227.963)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1215",
    "data-name": "Caminho 1215",
    d: "M191.953,325.706v-3.579h-4.432v3.579h-1.2v-8.012h1.2v3.363h4.432v-3.363h1.2v8.012Z",
    transform: "translate(-133.695 -227.963)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1216",
    "data-name": "Caminho 1216",
    d: "M226.294,325.706l-.648-1.657h-3.928l-.648,1.657h-1.321l3.183-8.012h1.5l3.183,8.012Zm-2.619-6.966-1.609,4.24H225.3Z",
    transform: "translate(-157.682 -227.963)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1217",
    "data-name": "Caminho 1217",
    d: "M261.488,325.706l-1.91-3.087h-1.5v3.087h-1.2v-8.012h3.375a2.387,2.387,0,0,1,2.57,2.462,2.235,2.235,0,0,1-1.993,2.342l2.054,3.207Zm-1.394-6.955h-2.018v2.811h2.018a1.408,1.408,0,1,0,0-2.811",
    transform: "translate(-184.323 -227.963)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1218",
    "data-name": "Caminho 1218",
    d: "M295.922,325.706V319.34l-2.595,6.366h-.5l-2.595-6.366v6.366h-1.2v-8.012h1.718l2.33,5.753,2.33-5.753h1.718v8.012Z",
    transform: "translate(-207.394 -227.963)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1219",
    "data-name": "Caminho 1219",
    d: "M333.468,325.706l-.648-1.657h-3.928l-.649,1.657h-1.321l3.183-8.012h1.5l3.183,8.012Zm-2.619-6.966-1.609,4.24h3.231Z",
    transform: "translate(-234.585 -227.963)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1220",
    "data-name": "Caminho 1220",
    d: "M345.151,216.165H325.926l-.414,4.508h.259s1.451-3.575,4.663-3.575h3.213v16.79c0,1.555-.57,2.332-1.969,2.384l-.363,0v.313h8.55v-.313l-.311,0c-1.4-.052-1.969-.777-1.969-2.384V217.15h3.109c3.161,0,4.664,3.575,4.664,3.575h.259Z",
    transform: "translate(-233.573 -155.111)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1221",
    "data-name": "Caminho 1221",
    d: "M140.288,230.166c0-3.26-2.547-5.043-6.724-7.03-3.26-1.528-4.228-2.394-4.228-3.923s1.172-2.6,3.057-2.9a6.28,6.28,0,0,1,2.394.153,5.408,5.408,0,0,1,3.821,3.566h.254v-3.362a11.777,11.777,0,0,0-6.011-1.426c-2.9,0-6.418,1.477-6.418,5.3a4.7,4.7,0,0,0,1.528,3.566c.713.713,1.579,1.528,4.992,3.209,3.566,1.681,4.534,2.6,4.534,4.279,0,2.9-2.7,3.617-4.483,3.617a6.781,6.781,0,0,1-6.572-3.871h-.306v3.413a15.262,15.262,0,0,0,6.928,1.426c3.209.051,7.234-2.139,7.234-6.011",
    transform: "translate(-90.503 -154.444)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1222",
    "data-name": "Caminho 1222",
    d: "M82.909,230.166c0-3.26-2.547-5.043-6.724-7.03-3.26-1.528-4.228-2.394-4.228-3.923s1.172-2.6,3.056-2.9a6.281,6.281,0,0,1,2.394.153,5.407,5.407,0,0,1,3.821,3.566h.255v-3.362a11.778,11.778,0,0,0-6.011-1.426c-2.9,0-6.419,1.477-6.419,5.3a4.779,4.779,0,0,0,1.528,3.566c.713.713,1.579,1.528,4.992,3.209,3.566,1.681,4.534,2.6,4.534,4.279,0,2.9-2.7,3.617-4.534,3.617A6.782,6.782,0,0,1,69,231.338H68.7v3.413a15.261,15.261,0,0,0,6.928,1.426c3.26.051,7.285-2.139,7.285-6.011",
    transform: "translate(-49.293 -154.444)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1223",
    "data-name": "Caminho 1223",
    d: "M16.581,232.074s-1.658,3.575-5.389,3.575H6.27V226.27H9.9c3.523,0,3.782,2.643,3.782,2.643h.259v-5.907H13.68s-.259,2.332-3.782,2.332H6.27V217.2h4.767a4.719,4.719,0,0,1,4.767,3.523h.311v-4.56H0v.311A2.308,2.308,0,0,1,2.332,218.7v15.183a2.263,2.263,0,0,1-2.021,2.384H0v.311H16.063l.777-4.508Z",
    transform: "translate(0 -155.111)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1224",
    "data-name": "Caminho 1224",
    d: "M454.377,235.874c-1.207-.046-1.895-.5-2.628-1.964l-8.395-18.291h-.985l-7.047,18.24a3.349,3.349,0,0,1-2.776,2v.332h6.559v-.311s-3.131-.175-2.125-2.85l1.451-3.886h7.047l1.917,4.352c.994,2.218-1.917,2.384-1.917,2.384l0,.311h8.9ZM438.9,228.21l2.8-7.617,3.42,7.617Z",
    transform: "translate(-310.377 -154.718)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1225",
    "data-name": "Caminho 1225",
    d: "M409.536,236.239a2.535,2.535,0,0,1-2.169-2.4V218.964a2.335,2.335,0,0,1,2.332-2.487v-.312h-8.6v.312a2.335,2.335,0,0,1,2.332,2.487v14.871c0,2.088-2.332,2.436-2.332,2.436v.311h8.439Z",
    transform: "translate(-287.81 -155.111)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1226",
    "data-name": "Caminho 1226",
    d: "M198.627,232.074s-1.658,3.575-5.389,3.575h-4.923V226.27h3.627c3.523,0,3.782,2.643,3.782,2.643h.259v-5.907h-.259s-.259,2.332-3.782,2.332h-3.627V217.2h4.767a4.719,4.719,0,0,1,4.767,3.523h.311v-4.56H182.046v.311a2.308,2.308,0,0,1,2.332,2.228v15.183a2.263,2.263,0,0,1-2.021,2.384h-.311v.311h16.063l.777-4.508Z",
    transform: "translate(-130.628 -155.111)",
    fill: "#1d1e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1227",
    "data-name": "Caminho 1227",
    d: "M248.275,216.164h5.755l11.5,14.924V218.911a2.318,2.318,0,0,0-2.332-2.436v-.311H269v.311a2.318,2.318,0,0,0-2.332,2.436v17.811h-1.582L251.8,219.741v14.2c0,1.555.57,2.278,1.969,2.33h.363v.312h-5.8v-.312h.363c1.4-.052,1.969-.724,1.969-2.33V219.067a2.416,2.416,0,0,0-2.384-2.592Z",
    transform: "translate(-178.151 -155.11)",
    fill: "#1d1e1c"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaDark);
export default __webpack_public_path__ + "static/media/pharma-dark.eaa142e942b8aaa60c985e06952e641a.svg";
export { ForwardRef as ReactComponent };